<template>
  <div class="user_login_style">
    <div class="user_login_style1">
      <div class="login_button_style">帐户注册</div>
      <div>
        <div class="login_form_style">
          <el-form ref="form" :model="user" :rules="rules" label-position="top">
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="姓(汉字)" prop="cgmFamily.firstName">
                  <el-input
                      v-model="user.cgmFamily.firstName"
                      placeholder="鈴木"
                      @input="firstNameChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="名(汉字)" prop="cgmFamily.lastName">
                  <el-input
                      v-model="user.cgmFamily.lastName"
                      placeholder="桃子"
                      @input="lastNameChange"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="姓(英文)" prop="cgmFamily.firstNameEn">
                  <el-input
                      v-model="user.cgmFamily.firstNameEn"
                      placeholder="LINGMU"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="名(英文)" prop="cgmFamily.lastNameEn">
                  <el-input
                      v-model="user.cgmFamily.lastNameEn"
                      placeholder="TAOZI"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="区号" prop="mobile">
                  <el-select v-model="user.mobileCode" placeholder="请选择区号">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机" prop="mobile">
                  <el-input v-model="user.mobile" placeholder="请输入手机"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="验证码" prop="smsCode">
                  <div class="sms_code_style">
                    <div class="sms_code_style1">
                      <el-input
                          v-model="user.smsCode"
                          placeholder="请输入验证码"
                      />
                    </div>
                    <div
                        class="send_style"
                        v-if="!countdownDisplay"
                        @click="sms_register_click"
                    >
                      发送
                    </div>
                    <div v-if="countdownDisplay" class="time_style">
                      <el-statistic
                          :value="deadline"
                          :time-indices="countdownDisplay"
                          format="ss"
                          @finish="countdownFinish"
                      >
                        <template slot="suffix">s</template>
                      </el-statistic>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码" prop="password">
                  <el-input
                      v-model="user.password"
                      placeholder="请输入6位数字"
                      show-password
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="邀请码" prop="agentId">
                  <el-input
                      :disabled="agentIdQuery"
                      v-model="user.agentId"
                      placeholder="请输入邀请码"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <van-field
                v-model="user.cgmFamily.cardId"
                label="身份证"
                placeholder="请输入身份证(非必填)"
            />
            <van-field
                readonly
                clickable
                :value="user.cgmFamily.cgmAddress.province_city_district"
                label="省市区"
                @click="province_city_district_show = true"
            />
            <van-popup
                v-model="province_city_district_show"
                round
                position="bottom"
                :style="{ height: '40%' }"
            >
              <van-area
                  title="省市区"
                  :area-list="areaList"
                  @confirm="address_confirm"
                  @cancel="address_cancel"
              />
            </van-popup>
            <van-field
                v-model="user.cgmFamily.cgmAddress.address"
                label="地址"
            />
            <!-- <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item>
                  <el-checkbox v-model="checked">同意</el-checkbox>
                  <span class="protocol_style" @click="protocol_click">
                    利用规约 </span
                  >以及<span class="protocol_style" @click="protocol1_click">
                    个人信息保护
                  </span>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-form-item>
              <el-checkbox v-model="checked">同意</el-checkbox>
              <span class="protocol_style" @click="protocol_click">
                利用规约</span
              >以及<span class="protocol_style" @click="protocol1_click">
                个人信息保护
              </span>
            </el-form-item>
          </el-form>
        </div>
        <div class="confirm_style">
          <el-button type="primary" @click="register_click">家庭账户注册</el-button>
        </div>
      </div>
      <el-divider>已经持有账户的用户</el-divider>
      <div class="login_style">
        <div class="login_style1" @click="log_click">登录</div>
      </div>
    </div>
  </div>
</template>
<script>
import {pinyin} from "pinyin-pro";
import {protocol1_href, protocol_href} from "../assets/config/img";
import {areaList} from "@vant/area-data";
import {Dialog, Toast} from "vant";
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      options: [
        {
          value: "86",
          label: "中国+86",
        },
        {
          value: "852",
          label: "中国香港+852",
        },
      ],
      areaList,
      province_city_district_show: false,
      checked: false,
      deadline: null,
      countdownDisplay: false,
      user: {
        mobileCode: null,
        mobile: null,
        smsCode: null,
        password: null,
        agentId: null,
        cgmFamily: {
          firstName: null,
          firstNameEn: null,
          lastName: null,
          lastNameEn: null,
          cardId: null,
          cgmAddress: {
            province: null,
            city: null,
            district: null,
            address: null,
            province_city_district: null,
          },
        },
      },
      agentIdQuery: false,
      rules: {
        "cgmFamily.firstName": [
          {required: true, message: "请输入姓", trigger: "blur"},
        ],
        "cgmFamily.firstNameEn": [
          {required: true, message: "请输入姓(英文)", trigger: "blur"},
        ],
        "cgmFamily.lastName": [
          {required: true, message: "请输入名", trigger: "blur"},
        ],
        "cgmFamily.lastNameEn": [
          {required: true, message: "请输入名(英文)", trigger: "blur"},
        ],
        mobileCode: [{required: true, message: "请选择区号", trigger: "blur"}],
        mobile: [{required: true, message: "请输入手机", trigger: "blur"}],
        smsCode: [{required: true, message: "请输入验证码", trigger: "blur"}],
        password: [{required: true, message: "请输入6位数字", trigger: "blur"}],
        agentId: [{required: true, message: "请输入邀请码", trigger: "blur"}],
      },
    };
  },
  mounted() {
    if (this.cgmUserVO) {
      this.$router.push("/");
    } else {
      if (this.$route.query.agentId) {
        this.agentIdQuery = true;
        this.user.agentId = this.$route.query.agentId;
      }
    }
  },
  methods: {
    firstNameChange(v) {
      this.user.cgmFamily.firstNameEn = pinyin(v, {
        toneType: "none",
      }).toUpperCase();
    },
    lastNameChange(v) {
      this.user.cgmFamily.lastNameEn = pinyin(v, {
        toneType: "none",
      }).toUpperCase();
    },
    log_click() {
      this.$router.push("/login");
    },
    protocol_click() {
      window.open(protocol_href);
    },
    protocol1_click() {
      window.open(protocol1_href);
    },
    countdownFinish() {
      this.countdownDisplay = false;
      this.deadline = null;
    },
    sms_register_click() {
      if (this.user.mobile == null) {
        this.$message({type: "error", message: "请输入手机！"});
      } else {
        this.axios
            .post(
                "/smsRegister",
                {
                  mobileCode: this.user.mobileCode,
                  mobile: this.user.mobile
                },
                {headers: {"Content-Type": "application/x-www-form-urlencoded"}}
            )
            .then((res) => {
              if (res.data.code === 200) {
                this.deadline = Date.now() + 1000 * 60;
                this.countdownDisplay = true;
                this.$message({type: "success", message: "发送成功！"});
              }
            });
      }
    },
    address_confirm(v) {
      this.user.cgmFamily.cgmAddress.province = v[0].name;
      this.user.cgmFamily.cgmAddress.city = v[1].name;
      this.user.cgmFamily.cgmAddress.district = v[2].name;
      this.user.cgmFamily.cgmAddress.province_city_district =
          v[0].name + v[1].name + v[2].name;
      this.province_city_district_show = false;
    },
    address_cancel() {
      this.province_city_district_show = false;
    },
    register_click() {
      if (this.checked === false) {
        // this.$message({
        //   type: "error",
        //   message: "请同意利用规约以及个人信息保护！",
        // });
        Toast.success("请同意利用规约以及个人信息保护");
        return;
      }
      if (
          this.user.cgmFamily.firstName == null ||
          this.user.cgmFamily.firstName === ""
      ) {
        Toast.success("请输入姓");
        return;
      }
      if (
          this.user.cgmFamily.lastName == null ||
          this.user.cgmFamily.lastName === ""
      ) {
        Toast.success("请输入名");
        return;
      }
      if (
          this.user.cgmFamily.cgmAddress.province == null ||
          this.user.cgmFamily.cgmAddress.province === ""
      ) {
        Toast.success("请选择省市区");
        return;
      }
      if (
          this.user.cgmFamily.cgmAddress.address == null ||
          this.user.cgmFamily.cgmAddress.address === ""
      ) {
        Toast.success("请输入地址");
        return;
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          Dialog.confirm({
            title: '确认收货地址',
            message: '本产品系海外直邮，请再一次确认您的收货地址，确保收件正常',
          })
              .then(() => {
                this.axios.post("/register", this.user).then((res) => {
                  if (res.data.code === 200) {
                    this.$router.push("/login");
                    this.$message({
                      type: "success",
                      message: "注册成功，请登录",
                    });
                  }
                });
              })
              .catch(() => {
              });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 768px) {
  .user_login_style {
    padding: 20px !important;
  }
}

::v-deep .el-button {
  border-color: rgb(229, 28, 81);
  background: rgb(229, 28, 81);
  padding: 20px 18px;
  font-size: 18px;
}

.login_style {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_style1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 50px;
  border: 1px solid #e5e9f0;
  background: #ffffff;
  color: #223344;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
}

.protocol_style {
  color: rgb(229, 28, 81);
  font-weight: bold;
  cursor: pointer;
}

.send_style {
  border-radius: 4px;
  color: #223344;
  border: 1px solid #e5e9f0;
  font-weight: bold;
  width: 100px;
  text-align: center;
  background: #fff;
  cursor: pointer;
}

.time_style {
  display: flex;
  align-items: center;
  border-radius: 4px;
  color: #223344;
  border: 1px solid #e5e9f0;
  font-weight: bold;
  width: 100px;
  text-align: center;
  background: #fff;
}

.sms_code_style {
  display: flex;
  gap: 10px;
}

.sms_code_style1 {
  width: 80%;
}

.user_login_style {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f6f7;
  padding: 40px;
}

.user_login_style1 > div {
  margin-bottom: 40px;
}

.login_button_style {
  // margin-left: 40px;
  font-size: 27px;
  color: rgb(34, 51, 68);
  font-weight: bold;
}

.login_form_style {
  margin-bottom: 40px;
}

.confirm_style {
  text-align: center;
}
</style>
